export function isRailwayProjectNameConflict(detail: string): boolean {
  return /already exists|name.*taken|duplicate.*name/i.test(detail)
}
